import { motion } from "framer-motion"
import { FiChevronLeft, FiSearch } from "react-icons/fi"
import BottomSheet from "../../../../components/categories_list/BottomSheet"
import type { CategoryBottomSheetProps } from "../../types/categories"

const CategoryBottomSheet: React.FC<CategoryBottomSheetProps> = ({
    open,
    onClose,
    selectedCategory,
    subcategories,
    search,
    onSearchChange,
    onSubcategoryTap
}) => {
    return (
        <BottomSheet
            open={open}
            onClose={onClose}
            title={
                <div className="flex items-center gap-2">
                    <button onClick={onClose} className="text-xl text-content-default" aria-label="Retour">
                        <FiChevronLeft />
                    </button>
                    <span className="truncate max-w-[200px] text-content-default">{selectedCategory?.name}</span>
                </div>
            }
        >
            <div className="mb-2">
                <div className="flex items-center bg-surface-tertiary rounded-lg px-2 py-1">
                    <FiSearch className="text-content-tertiary mr-2" />
                    <input
                        type="text"
                        placeholder="Rechercher une sous-catégorie"
                        value={search}
                        onChange={(e) => onSearchChange(e.target.value)}
                        className="bg-transparent outline-none flex-1 py-1 text-sm text-content-default"
                    />
                </div>
            </div>
            <div className="flex flex-col gap-2 max-h-72 overflow-y-auto">
                {subcategories.length === 0 && (
                    <div className="text-content-tertiary text-center py-8">Aucune sous-catégorie</div>
                )}
                {subcategories.map((subcat, index) => (
                    <motion.button
                        key={subcat.id}
                        initial={{ opacity: 0, x: -20 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ delay: index * 0.05 }}
                        whileHover={{ scale: 1.02 }}
                        whileTap={{ scale: 0.98 }}
                        className="flex items-center gap-3 p-3 rounded-lg bg-surface-secondary hover:bg-primary-tertiary transition"
                        onClick={() => onSubcategoryTap(subcat)}
                    >
                        <img
                            src={subcat.image || "/default-subcategory-image.png"}
                            alt={subcat.name}
                            className="w-10 h-10 rounded object-cover border border-solid-100"
                        />
                        <span className="text-sm font-medium text-content-default flex-1 text-left truncate">
                            {subcat.name}
                        </span>
                        <span className="bg-primary-tertiary text-primary-default text-xs px-2 py-0.5 rounded-full">
                            {subcat.adCount ?? 0} articles
                        </span>
                    </motion.button>
                ))}
            </div>
        </BottomSheet>
    )
}

export default CategoryBottomSheet 